<template>
    <div>
        <div class="pim-product-table-list__content">
            <slot/>
        </div>
        <span class="row">
            <div class="pim-product-table-list__hr">
                <hr>
            </div>
        </span>
    </div>
</template>

<script>
export default {
    name: "pim-product-table-list-row",
}
</script>
